import { ColDef, ColGroupDef } from "ag-grid-enterprise";
import { PreferredBrandView } from "models/dbModels/preferredBrands/PreferredBrand";
import { Link } from "react-router-dom";

export function getPreferredBrandsConfig(): (ColDef<PreferredBrandView> | ColGroupDef<PreferredBrandView>)[]| null
{
    return [
        {
            checkboxSelection: true,
            headerCheckboxSelection: true,
            width: 45,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
        },
        {
            headerName: "Name",
            field: "name",
            flex: 1,
            cellClass: "aggrid-header-link-lext cursor-pointer",
            minWidth: 200,
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {
                        children: <Link to={`/app/preferred-brand/${params.data?.id}`} >{params.data?.name}</Link>
                    }
                }
            },
        },

    ];
}